/*
* カルーセル（Embla Carousel）
*/
import EmblaCarousel from 'embla-carousel';

export default class TopPageSlider {
  constructor() {
    this.$emblaContainer = document.querySelector('[data-target="topEmblaContainer"]');
    this.$sliderPagination = document.querySelector('[data-target="sliderPagination"]');
    this.$sliderNavigationNext = document.querySelector('[data-target="sliderNavigationNext"]');
    this.$sliderNavigationPrev = document.querySelector('[data-target="sliderNavigationPrev"]');
    this.breakPoint = 767;
    this.emblaApi = null;
    this.hasBoundNavigation = false;
  }

  slider() {
    const viewportNode = this.$emblaContainer.querySelector('.embla__viewport');
    this.emblaApi = EmblaCarousel(viewportNode, {
      loop: true,
      align: 'center',
      containScroll: false
    });

    // ナビゲーション（リスナーは1回だけ登録）
    if (!this.hasBoundNavigation) {
      this.$sliderNavigationPrev.addEventListener('click', () => { if (this.emblaApi) this.emblaApi.scrollPrev(); });
      this.$sliderNavigationNext.addEventListener('click', () => { if (this.emblaApi) this.emblaApi.scrollNext(); });
      this.hasBoundNavigation = true;
    }

    // ページネーション
    this.setupDots();
  }

  setupDots() {
    const scrollSnaps = this.emblaApi.scrollSnapList();
    this.$sliderPagination.innerHTML = scrollSnaps
      .map(() => '<button class="embla__dot" type="button"></button>')
      .join('');

    const dots = this.$sliderPagination.querySelectorAll('.embla__dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.emblaApi.scrollTo(index));
    });

    const updateDots = () => {
      const selected = this.emblaApi.selectedScrollSnap();
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === selected);
      });
    };

    this.emblaApi.on('select', updateDots);
    this.emblaApi.on('init', updateDots);
  }

  attachEvent() {
    if (this.$emblaContainer) {
      window.addEventListener('DOMContentLoaded', () => {
        if (this.breakPoint >= window.innerWidth) {
          this.slider();
        }
      });
      window.addEventListener('resize', () => {
        if (this.breakPoint < window.innerWidth && this.emblaApi) {
          this.emblaApi.destroy();
          this.emblaApi = null;
        } else if (this.breakPoint >= window.innerWidth && !this.emblaApi) {
          this.slider();
        }
      });
    }
  }
}
